import { useMutation } from '@apollo/client';
import Loader from 'components/Loader';
import SmkAsyncSelect from 'components/SmkAsyncSelect';
import SmkAsyncSelectGraphql from 'components/SmkAsyncSelect/customSelectGraphql';
import TextEditor from 'components/TextEditor';
import { ADD_POST_COMMENT } from 'containers/community/graphql/community.mutation';
import { COMMUNITY_POSTS_SEARCH } from 'containers/community/graphql/community.query';
import { isEmpty } from 'lodash';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Button, FormGroup, Label, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { API_BASE_URL, USER_ROLE } from 'utils/constants';

const AddCommentModal = ({ postId, selectedReplyComment, isOpen, toggleModal }) => {
  const [updatedText, setUpdatedText] = useState('');
  const [selectedPost, setSelectedPost] = useState(null);
  const [createdBy, setCreatedBy] = useState(null);
  toast.configure();

  const [addUserComment, { loading: addUserCommentsLoading }] = useMutation(ADD_POST_COMMENT, {
    onCompleted: () => {
      window.location.reload();
    },
    onError: (err) => {
      console.error('Error:', err);
    },
  });

  const handleSave = async () => {
    if (isEmpty(createdBy) || isEmpty(updatedText.trim()) || (!postId && isEmpty(selectedPost))) {
      toast.error('Please fill all the required fields');
      return;
    }

    //     {
    //     "postId": "adb211cb-35df-441e-b60d-e58893640277",
    //     "commentId": "aaf1ea87-3989-4f17-b03d-fde3b5d412b6",
    //     "content": "<p>123123</p>",
    //     "replyToUserId": 184182,
    //     "isReplyToComment": true,
    //     "mediaId": -1
    // }

    toggleModal();
    await addUserComment({
      variables: {
        createDTO: {
          createdById: createdBy?.value || null,
          postId: postId || selectedPost?.value,
          ...(!isEmpty(selectedReplyComment?.commentId) ? { commentId: selectedReplyComment?.commentId } : {}),
          ...(selectedReplyComment?.isNested
            ? { isReplyToComment: true, replyToUserId: selectedReplyComment?.replyToUserId }
            : {}),

          content: updatedText,
        },
      },
    });
  };

  const handleSelectChange = (res) => {
    if (!isEmpty(res)) {
      setSelectedPost({
        label: res?.title,
        value: res?.id,
      });
    } else {
      setSelectedPost(null);
    }
  };

  return (
    <>
      <Loader isActive={addUserCommentsLoading} />
      <Modal centered size="lg" isOpen={isOpen}>
        <ModalHeader toggle={toggleModal}>Add Comment</ModalHeader>
        <ModalBody className="p-4">
          {!postId && (
            <FormGroup className="mb-4">
              <Label>
                Select Post
                <span className="text-danger">*</span>
              </Label>
              <SmkAsyncSelectGraphql
                isValueSlugify={true}
                acceptedKey={'name'}
                acceptedValue={'id'}
                placeholder="Type Post title.."
                searchKeyName="name"
                query={COMMUNITY_POSTS_SEARCH}
                queryName={'admin_community_post_search'}
                dtoName={'searchDTO'}
                value={selectedPost}
                filters={{
                  autoComplete: true,
                  active: true,
                  page: 1,
                  size: 20,
                  sortBy: 'createdDate',
                  sortOrder: -1,
                }}
                onChange={handleSelectChange}
              />
            </FormGroup>
          )}

          <FormGroup className="mb-4">
            <Label>
              CreatedBy <span className="text-danger">*</span>
            </Label>
            <SmkAsyncSelect
              acceptedKey={'displayName'}
              // combineLabelKey={'email'}
              searchKeyName="name"
              acceptedValue={'id'}
              placeholder="Type user name.."
              onChange={(res) => {
                const val = isEmpty(res)
                  ? null
                  : {
                      ...res,
                      label: res?.displayName,
                      value: res?.id,
                    };
                setCreatedBy(val);
              }}
              fetchUrl={`${API_BASE_URL}/user/admin/search`}
              filters={{
                autoComplete: true,
                page: 1,
                size: 10,
                sortBy: 'id',
                sortOrder: 0,
                roleIds: [USER_ROLE.STAFF, USER_ROLE.OFFLINE_USERS],
              }}
              value={createdBy || null}
            />
          </FormGroup>

          <FormGroup>
            <Label>
              Content <span className="text-danger">*</span>
            </Label>
            <TextEditor
              simple
              features={[['bold', 'underline', 'italic', 'list']]}
              height={200}
              initialValue={updatedText}
              onChange={(val) => setUpdatedText(val)}
            />
          </FormGroup>

          <div className="mt-4 mb-2">
            <Button color="primary" className="me-3" onClick={handleSave}>
              Add Comment
            </Button>
            <Button color="light" onClick={() => toggleModal()}>
              Cancel
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default AddCommentModal;
